module.exports = __webpack_public_path__ + "media/images/logo/niet_gebruikt/lsp-aorta-viewer-04cb06e638aeb02579ad4e001aebf501.svg";